import React from "react";
import CargoItemComponent from "./cargo-item.component";
import { ICargoItem } from "./types";

const CargoItemContainer = (props: ICargoItem) => {
  return <CargoItemComponent {...props} />;
};

export default CargoItemContainer;
